import {Component, Input, OnInit} from '@angular/core';
import {AosOrderDataInterface, AosOrderInterface} from '../../../../models/sharedinterface';
import {unserialize} from 'locutus/php/var';
import * as moment from 'moment';
import {I18nService} from '../../../../shared/services/i18n.service';

@Component({
  selector: 'app-aos-order-details',
  templateUrl: './aos-order-details.component.html',
  styleUrls: ['./aos-order-details.component.scss']
})
export class AosOrderDetailsComponent implements OnInit {

  @Input() order: AosOrderInterface;

  public decodedOrderData: AosOrderDataInterface;
  public decodedOrderAddressFields: {};

  constructor(public i18n: I18nService) {
  }

  ngOnInit(): void {
    this.decodedOrderData = unserialize(this.order.data);
    this.decodedOrderAddressFields = unserialize(this.decodedOrderData.addressFields);
  }

  getDate() {
    return moment(new Date(this.order.created.date)).format('DD/MM/YYYY HH:mm');
  }

  getPublicationDate() {
    return moment(new Date(this.decodedOrderData.publicationDate)).format('DD/MM/YYYY');
  }

  getShipmentDate() {
    return moment(new Date(this.order.shipmentDate)).format('DD/MM/YYYY');
  }
}
